import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  removeLocation(e) {
    const id = e.currentTarget.dataset.id
    const el = document.querySelector(`#location_ids_${Number(id)}`)
    el.click();
  }
}
